/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_ImageInputs */

const vi_tea_purchase_image = /** @type {(inputs: Tea_Purchase_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hình ảnh`)
};

/**

* @param {Tea_Purchase_ImageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_image = /** @type {((inputs?: Tea_Purchase_ImageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_ImageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_image(inputs)
});